/**
 * Code prefixes per area — import and prepend so Sentry codes stay
 * consistently namespaced and the prefix itself is changed in one place.
 * Usage: `code: \`${LOG_CODE_PREFIX.MAILPRO}ANNIVERSARY_NOTE_LOAD_FAILED\``
 */
export const LOG_CODE_PREFIX = {
  MAILPRO: 'MAILPRO_',
  PMA: 'PMA_',
};

/**
 * Stable module names for Sentry search (tag module:"cover_photo").
 */
export const LOG_MODULES = {
  COVER_PHOTO: 'cover_photo',
  BACK_PAGE_UPLOAD: 'back_page_upload',
  MISSION_STATEMENT_PHOTO: 'mission_statement_photo',
  AUTH_SIGN_IN: 'auth_sign_in',
  AUTH_FORGOT_PASSWORD: 'auth_forgot_password',
  AUTH_RESET_PASSWORD: 'auth_reset_password',
  CREDIT_CARD: 'credit_card',
  SESSION_SWITCH: 'session_switch',
  SESSION_REFRESH: 'session_refresh',
  API: 'api',
  LOGOUT: 'logout',
  AUTH_GUARD: 'auth_guard',
  MAILPRO: 'mailpro',
  AGENT_MISSIONS: 'agent_missions',
  CLIENT_TESTIMONIALS: 'client_testimonials',
  YEAR_END_STATEMENT: 'year_end_statement',
  UPDATE_PROFILE: 'update_profile',
  PMA_ADMIN: 'pma_admin',
  LIVE_CHAT: 'live_chat',
  AGENT_REGISTRATION: 'agent_registration',
};

export const LOG_DEDUPE_TTL_MS = 10 * 60 * 1000;
export const LOG_DEDUPE_MAX_CACHE_SIZE = 200;
export const LOG_MESSAGE_TRUNCATE = 120;
